import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function VesselManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'register'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  const [vessels, setVessels] = useState([{
    vesselId: 'VSL-001',
    vesselName: 'MV Sundarban-1',
    regNumber: 'REG-2024-001',
    ownerName: 'Rahim Uddin',
    vesselType: 'Trawler',
    contactNumber: '01711223344',
    email: 'rahim@vessel.com',
    status: 'active' as const
  }, {
    vesselId: 'VSL-002',
    vesselName: 'FV Padma-3',
    regNumber: 'REG-2024-002',
    ownerName: 'Karim Sheikh',
    vesselType: 'Boat',
    contactNumber: '01811334455',
    email: 'karim@vessel.com',
    status: 'active' as const
  }, {
    vesselId: 'VSL-003',
    vesselName: 'BT Meghna-7',
    regNumber: 'REG-2024-003',
    ownerName: 'Abdul Hakim',
    vesselType: 'Ship',
    contactNumber: '01911445566',
    email: 'abdul@vessel.com',
    status: 'expired' as const
  }, {
    vesselId: 'VSL-004',
    vesselName: 'LV Jamuna-2',
    regNumber: 'REG-2024-004',
    ownerName: 'Jamal Hossain',
    vesselType: 'Launch',
    contactNumber: '01611556677',
    email: 'jamal@vessel.com',
    status: 'active' as const
  }, {
    vesselId: 'VSL-005',
    vesselName: 'FT Karnaphuli-5',
    regNumber: 'REG-2024-005',
    ownerName: 'Fatema Begum',
    vesselType: 'Trawler',
    contactNumber: '01511667788',
    email: 'fatema@vessel.com',
    status: 'suspended' as const
  }]);
  const [formData, setFormData] = useState({
    vesselName: '',
    regNumber: '',
    regDate: '',
    issuingAuthority: '',
    blcNo: '',
    licenseIssueDate: '',
    licenseExpiryDate: '',
    vesselLength: '',
    vesselWidth: '',
    depthDraft: '',
    engineType: '',
    engineNumber: '',
    enginePower: '',
    fuelType: '',
    carryingCapacity: '',
    vesselType: '',
    operatingArea: '',
    ownerName: '',
    ownerNid: '',
    contactNumber: '',
    emailAddress: '',
    address: '',
    organization: '',
    village: '',
    union: '',
    upazila: '',
    district: '',
    range: '',
    route: '',
    blcAttachment: ''
  });
  const columns = [{
    key: 'vesselId',
    label: 'Vessel ID'
  }, {
    key: 'vesselName',
    label: 'Vessel Name'
  }, {
    key: 'regNumber',
    label: 'Registration Number'
  }, {
    key: 'ownerName',
    label: 'Owner Name'
  }, {
    key: 'vesselType',
    label: 'Vessel Type'
  }, {
    key: 'contactNumber',
    label: 'Contact Number'
  }, {
    key: 'email',
    label: 'Email'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-2875" />
  }];
  const filters = [{
    key: 'vesselType',
    label: 'Vessel Type',
    options: ['Boat', 'Launch', 'Ship', 'Trawler']
  }, {
    key: 'status',
    label: 'Status',
    options: ['Active', 'Expired', 'Suspended']
  }];
  const wizardSteps = [{
    title: 'Vessel Details',
    description: 'Enter vessel and technical information'
  }, {
    title: 'Owner & Location',
    description: 'Enter owner and operational details'
  }, {
    title: 'Documents',
    description: 'Upload required certificates'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-2876">
      <div data-id="element-2877">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-2878">Vessel Management</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-2879">
          Manage boat registrations and licenses
        </p>
      </div>

      <div className="border-b border-gray-200" data-id="element-2880">
        <div className="flex gap-4" data-id="element-2881">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-2882">
            Vessel Registry
          </button>
          <button onClick={() => setActiveTab('register')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'register' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-2883">
            Register Vessel
          </button>
        </div>
      </div>

      {activeTab === 'list' ? <DataTable columns={columns} data={vessels} filters={filters} onDataChange={setVessels} searchPlaceholder="Search vessels..." data-id="element-2884" /> : <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.vesselName || !formData.regNumber) {
        alert('Please fill in all required fields.');
        return;
      }
      alert('Vessel registered successfully!');
      setCurrentStep(0);
      setActiveTab('list');
      setFormData({
        vesselName: '',
        regNumber: '',
        regDate: '',
        issuingAuthority: '',
        blcNo: '',
        licenseIssueDate: '',
        licenseExpiryDate: '',
        vesselLength: '',
        vesselWidth: '',
        depthDraft: '',
        engineType: '',
        engineNumber: '',
        enginePower: '',
        fuelType: '',
        carryingCapacity: '',
        vesselType: '',
        operatingArea: '',
        ownerName: '',
        ownerNid: '',
        contactNumber: '',
        emailAddress: '',
        address: '',
        organization: '',
        village: '',
        union: '',
        upazila: '',
        district: '',
        range: '',
        route: '',
        blcAttachment: ''
      });
    }} data-id="element-2885">
          {currentStep === 0 && <div className="space-y-4" data-id="element-2886">
              <div className="grid grid-cols-2 gap-4" data-id="element-2887">
                <div data-id="element-2888">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2889">
                    Vessel Name *
                  </label>
                  <input type="text" required value={formData.vesselName} onChange={e => setFormData({
              ...formData,
              vesselName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2890" />
                </div>
                <div data-id="element-2891">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2892">
                    Registration Number *
                  </label>
                  <input type="text" required value={formData.regNumber} onChange={e => setFormData({
              ...formData,
              regNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2893" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-2894">
                <div data-id="element-2895">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2896">
                    Registration Date
                  </label>
                  <input type="date" value={formData.regDate} onChange={e => setFormData({
              ...formData,
              regDate: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2897" />
                </div>
                <div data-id="element-2898">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2899">
                    Issuing Authority
                  </label>
                  <input type="text" value={formData.issuingAuthority} onChange={e => setFormData({
              ...formData,
              issuingAuthority: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2900" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-2901">
                <div data-id="element-2902">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2903">
                    BLC No.
                  </label>
                  <input type="text" value={formData.blcNo} onChange={e => setFormData({
              ...formData,
              blcNo: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2904" />
                </div>
                <div data-id="element-2905">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2906">
                    License Issue Date
                  </label>
                  <input type="date" value={formData.licenseIssueDate} onChange={e => setFormData({
              ...formData,
              licenseIssueDate: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2907" />
                </div>
                <div data-id="element-2908">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2909">
                    License Expiry Date
                  </label>
                  <input type="date" value={formData.licenseExpiryDate} onChange={e => setFormData({
              ...formData,
              licenseExpiryDate: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2910" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-2911">
                <div data-id="element-2912">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2913">
                    Vessel Length
                  </label>
                  <input type="text" value={formData.vesselLength} onChange={e => setFormData({
              ...formData,
              vesselLength: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2914" />
                </div>
                <div data-id="element-2915">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2916">
                    Vessel Width
                  </label>
                  <input type="text" value={formData.vesselWidth} onChange={e => setFormData({
              ...formData,
              vesselWidth: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2917" />
                </div>
                <div data-id="element-2918">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2919">
                    Depth / Draft
                  </label>
                  <input type="text" value={formData.depthDraft} onChange={e => setFormData({
              ...formData,
              depthDraft: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2920" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-2921">
                <div data-id="element-2922">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2923">
                    Engine Type
                  </label>
                  <input type="text" value={formData.engineType} onChange={e => setFormData({
              ...formData,
              engineType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2924" />
                </div>
                <div data-id="element-2925">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2926">
                    Engine Number
                  </label>
                  <input type="text" value={formData.engineNumber} onChange={e => setFormData({
              ...formData,
              engineNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2927" />
                </div>
                <div data-id="element-2928">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2929">
                    Engine Power (HP)
                  </label>
                  <input type="text" value={formData.enginePower} onChange={e => setFormData({
              ...formData,
              enginePower: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2930" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-2931">
                <div data-id="element-2932">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2933">
                    Fuel Type
                  </label>
                  <select value={formData.fuelType} onChange={e => setFormData({
              ...formData,
              fuelType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2934">
                    <option value="" data-id="element-2935">Select Fuel</option>
                    <option value="Diesel" data-id="element-2936">Diesel</option>
                    <option value="Petrol" data-id="element-2937">Petrol</option>
                    <option value="CNG" data-id="element-2938">CNG</option>
                    <option value="Manual" data-id="element-2939">Manual</option>
                  </select>
                </div>
                <div data-id="element-2940">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2941">
                    Carrying Capacity
                  </label>
                  <input type="text" value={formData.carryingCapacity} onChange={e => setFormData({
              ...formData,
              carryingCapacity: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2942" />
                </div>
                <div data-id="element-2943">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2944">
                    Vessel Type
                  </label>
                  <select value={formData.vesselType} onChange={e => setFormData({
              ...formData,
              vesselType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2945">
                    <option value="" data-id="element-2946">Select Type</option>
                    <option value="Boat" data-id="element-2947">Boat</option>
                    <option value="Launch" data-id="element-2948">Launch</option>
                    <option value="Ship" data-id="element-2949">Ship</option>
                    <option value="Trawler" data-id="element-2950">Trawler</option>
                  </select>
                </div>
              </div>
              <div data-id="element-2951">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2952">
                  Operating Area
                </label>
                <input type="text" value={formData.operatingArea} onChange={e => setFormData({
            ...formData,
            operatingArea: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2953" />
              </div>
            </div>}

          {currentStep === 1 && <div className="space-y-4" data-id="element-2954">
              <div className="grid grid-cols-2 gap-4" data-id="element-2955">
                <div data-id="element-2956">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2957">
                    Owner Name *
                  </label>
                  <input type="text" required value={formData.ownerName} onChange={e => setFormData({
              ...formData,
              ownerName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2958" />
                </div>
                <div data-id="element-2959">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2960">
                    Owner NID / Passport No.
                  </label>
                  <input type="text" value={formData.ownerNid} onChange={e => setFormData({
              ...formData,
              ownerNid: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2961" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-2962">
                <div data-id="element-2963">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2964">
                    Contact Number
                  </label>
                  <input type="tel" value={formData.contactNumber} onChange={e => setFormData({
              ...formData,
              contactNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2965" />
                </div>
                <div data-id="element-2966">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2967">
                    Email Address
                  </label>
                  <input type="email" value={formData.emailAddress} onChange={e => setFormData({
              ...formData,
              emailAddress: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2968" />
                </div>
              </div>
              <div data-id="element-2969">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2970">
                  Address
                </label>
                <textarea rows={2} value={formData.address} onChange={e => setFormData({
            ...formData,
            address: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2971" />
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-2972">
                <div data-id="element-2973">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2974">
                    Organization
                  </label>
                  <select value={formData.organization} onChange={e => setFormData({
              ...formData,
              organization: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2975">
                    <option value="" data-id="element-2976">Select Organization</option>
                    <option value="Sundarban Fisheries Ltd" data-id="element-2977">
                      Sundarban Fisheries Ltd
                    </option>
                    <option value="Bay of Bengal Trading Co." data-id="element-2978">
                      Bay of Bengal Trading Co.
                    </option>
                    <option value="Khulna Honey Producers" data-id="element-2979">
                      Khulna Honey Producers
                    </option>
                    <option value="Mongla Port Services" data-id="element-2980">
                      Mongla Port Services
                    </option>
                    <option value="Satkhira Wood Industries" data-id="element-2981">
                      Satkhira Wood Industries
                    </option>
                  </select>
                </div>
                <div data-id="element-2982">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2983">
                    Village
                  </label>
                  <select value={formData.village} onChange={e => setFormData({
              ...formData,
              village: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2984">
                    <option value="" data-id="element-2985">Select Village</option>
                    <option value="Munshiganj" data-id="element-2986">Munshiganj</option>
                    <option value="Gabura" data-id="element-2987">Gabura</option>
                    <option value="Shyamnagar" data-id="element-2988">Shyamnagar</option>
                    <option value="Koyra" data-id="element-2989">Koyra</option>
                    <option value="Dacope" data-id="element-2990">Dacope</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-2991">
                <div data-id="element-2992">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2993">
                    Union
                  </label>
                  <select value={formData.union} onChange={e => setFormData({
              ...formData,
              union: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2994">
                    <option value="" data-id="element-2995">Select Union</option>
                    <option value="Burigoalini" data-id="element-2996">Burigoalini</option>
                    <option value="Gabura" data-id="element-2997">Gabura</option>
                    <option value="Munshiganj" data-id="element-2998">Munshiganj</option>
                    <option value="Koyra" data-id="element-2999">Koyra</option>
                    <option value="Dacope" data-id="element-3000">Dacope</option>
                  </select>
                </div>
                <div data-id="element-3001">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3002">
                    Upazila
                  </label>
                  <select value={formData.upazila} onChange={e => setFormData({
              ...formData,
              upazila: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3003">
                    <option value="" data-id="element-3004">Select Upazila</option>
                    <option value="Shyamnagar" data-id="element-3005">Shyamnagar</option>
                    <option value="Koyra" data-id="element-3006">Koyra</option>
                    <option value="Dacope" data-id="element-3007">Dacope</option>
                    <option value="Mongla" data-id="element-3008">Mongla</option>
                    <option value="Sarankhola" data-id="element-3009">Sarankhola</option>
                  </select>
                </div>
                <div data-id="element-3010">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3011">
                    District
                  </label>
                  <select value={formData.district} onChange={e => setFormData({
              ...formData,
              district: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3012">
                    <option value="" data-id="element-3013">Select District</option>
                    <option value="Satkhira" data-id="element-3014">Satkhira</option>
                    <option value="Khulna" data-id="element-3015">Khulna</option>
                    <option value="Bagerhat" data-id="element-3016">Bagerhat</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-3017">
                <div data-id="element-3018">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3019">
                    Range
                  </label>
                  <select value={formData.range} onChange={e => setFormData({
              ...formData,
              range: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3020">
                    <option value="" data-id="element-3021">Select Range</option>
                    <option value="Satkhira" data-id="element-3022">Satkhira</option>
                    <option value="Khulna" data-id="element-3023">Khulna</option>
                    <option value="Chandpai" data-id="element-3024">Chandpai</option>
                    <option value="Sarankhola" data-id="element-3025">Sarankhola</option>
                  </select>
                </div>
                <div data-id="element-3026">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3027">
                    Route
                  </label>
                  <input type="text" value={formData.route} onChange={e => setFormData({
              ...formData,
              route: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3028" />
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4" data-id="element-3029">
              <div data-id="element-3030">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3031">
                  Boat License Certificate (BLC) Attachment
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3032" />
                <p className="text-xs text-gray-500 mt-1" data-id="element-3033">
                  Upload PDF or Image file
                </p>
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-6" data-id="element-3034">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-3035">
                <div className="flex items-center justify-between mb-3" data-id="element-3036">
                  <h4 className="font-semibold text-gray-900" data-id="element-3037">
                    Vessel Details
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-3038">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-3039">
                  <div data-id="element-3040">
                    <span className="text-gray-600" data-id="element-3041">Name:</span>{' '}
                    <span className="font-medium" data-id="element-3042">
                      {formData.vesselName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-3043">
                    <span className="text-gray-600" data-id="element-3044">Reg No:</span>{' '}
                    <span className="font-medium" data-id="element-3045">
                      {formData.regNumber || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-3046">
                    <span className="text-gray-600" data-id="element-3047">Type:</span>{' '}
                    <span className="font-medium" data-id="element-3048">
                      {formData.vesselType || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-3049">
                <div className="flex items-center justify-between mb-3" data-id="element-3050">
                  <h4 className="font-semibold text-gray-900" data-id="element-3051">
                    Owner & Location
                  </h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-3052">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-3053">
                  <div data-id="element-3054">
                    <span className="text-gray-600" data-id="element-3055">Owner Name:</span>{' '}
                    <span className="font-medium" data-id="element-3056">
                      {formData.ownerName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-3057">
                    <span className="text-gray-600" data-id="element-3058">Contact:</span>{' '}
                    <span className="font-medium" data-id="element-3059">
                      {formData.contactNumber || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-3060">
                    <span className="text-gray-600" data-id="element-3061">Organization:</span>{' '}
                    <span className="font-medium" data-id="element-3062">
                      {formData.organization || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}